// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import { css } from "glamor";

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~ Style for Markdown
const markdownStyles = css({
  "& h2:first-child, h3:first-child, h4:first-child, h5:first-child, h6:first-child, p.md-cat:first-child": {
    marginTop: "0 !important",
  },
});
const markdownStylesClass = markdownStyles.toString();

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default markdownStylesClass;



// WEBPACK FOOTER //
// ./src/styles/markdownStyles.js